<template>
  <div>
    <a-drawer
      width="600"
      :title="drawerTitle"
      placement="right"
      :closable="false"
      v-model:visible="deviceVisible"
      @close="closeCreateDrawer"
    >
      <a-form
        ref="createFormRef"
        :rules="createFormRules"
        :model="createForm"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-item label="设备名称" name="name">
          <a-input :maxlength="100" v-model:value="createForm.name" />
        </a-form-item>
        <a-form-item label="Distinct_id" name="distinctId">
          <a-input :maxlength="100" v-model:value="createForm.distinctId" />
        </a-form-item>
      </a-form>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1
        }"
      >
        <a-button style="margin-right: 8px" @click="closeCreateDrawer"
          >取消</a-button
        >
        <a-button type="primary" @click="saveCreateDrawer">保存</a-button>
      </div>
    </a-drawer>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs, inject } from 'vue'
import { post_abDevice_save } from '@/server/modules/21937'
import { message } from 'ant-design-vue'
export default defineComponent({
  setup() {
    const initData = inject('initState')
    const state = reactive({
      labelCol: {
        span: 4
      },
      wrapperCol: {
        span: 14
      },
      createFormRef: null,
      closeCreateDrawer: () => {
        state.createFormRef.resetFields()
        initData.deviceVisible = false
      },
      saveCreateDrawer: () => {
        const { brandId, siteId, channelId, terminalId } =
          initData.baseInfo || initData.searchParams
        state.createFormRef.validate().then(async () => {
          const { success, retInfo } = await post_abDevice_save({
            ...{ brandId, siteId, channelId, terminalId },
            ...state.createForm
          })
          if (success) {
            state.createFormRef.resetFields()
            initData.getDeviceList()
            initData.deviceVisible = false
          } else {
            message.error(retInfo)
          }
        })
      },
      createForm: {
        name: '',
        distinctId: null
      },
      createFormRules: {
        name: [
          { required: true, message: '请输入设备名称', trigger: 'blur' },
          {
            validator: (rule, value) => {
              const regex = /^[\u4e00-\u9fa5a-zA-Z0-9_\-'"‘’“”]+$/
              if (!regex.test(value)) {
                return Promise.reject(
                  new Error(
                    '支持输入中文、英文、数字、下划线、中划线、引号、双引号，不支持特殊字符'
                  )
                )
              } else {
                return Promise.resolve()
              }
            },
            trigger: 'blur'
          }
        ],
        distinctId: [
          {
            required: true,
            message: '请输入distinctId',
            trigger: 'blur'
          }
        ]
      }
    })
    return {
      ...toRefs(initData),
      ...toRefs(state)
    }
  }
})
</script>
<style>
.self-process .ant-progress-inner {
  height: 40px;
  border-radius: 0px !important;
}
.self-process .ant-progress-inner .ant-progress-bg {
  height: 40px !important;
  border-radius: 0px !important;
}
</style>
